import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash";
import { CameraRounded, AttachFileRounded, CloseRounded, EditRounded } from '@material-ui/icons';
import { Box, Button, Grid, IconButton } from '@material-ui/core';
import { amber } from '@material-ui/core/colors';

class Photos extends Component {
	state = {
		files:this.props.photos,
		max: this.props.max || 4,
	}

	handleAddImage = async (e) => {
		e.preventDefault();
		let exist = this.state.files.length;
		let list = e.target.files;

		console.log("[INFO], Upload Image list", list);

		let max = (exist + list.length) > this.state.max ? (this.state.max - exist) : list.length // 4 pics max

		for (let i = 0; i < max; i++) {
			let reader = new FileReader();
			let file = list[i];
			reader.onloadend = async (upload) => {
				console.log("[INFO]onloadend upload reader ",i, reader);

				this.setState({ 
				...this.state,  
				files:[
					...this.state.files, 
					{ 
						"data_uri": upload.target.result, 
						"filename": file.name,
						"filetype": file.type,
					}
				]
				})
				this.props.photoList(this.state.files) // send photoList to Products component
			}
			await reader.readAsDataURL(file)// ??
		}
	}
		
	handleChange = (e, index) => {
		e.preventDefault();
		console.log("[INFO], Upload One Image", index);

		let reader = new FileReader();
		let file = e.target.files[0];
		var upload = {}

		let files = [
			...this.state.files.slice(0,index),
			{
				"data_uri": upload.target.result, 
				"filename": file.name,
				"filetype": file.type,
				
			},
			...this.state.files.slice(index+1),
		]
		reader.onloadend = (upload) => {
			this.setState({
				...this.state,
				files
			});
			this.props.photoList(this.state.files) // send photoList to src component
		}

		reader.readAsDataURL(file)
		
	}
	
	onRemoveImage = async (e, index) => {
		e.preventDefault();
		let files = [
			...this.state.files.slice(0,index), 
			...this.state.files.slice(index+1)
		]
		this.setState({
			...this.state,
			files
		});
		this.props.photoList(files)// send photoList to Products component
	}

	displayPhotos = () => {
		
		if( !isEmpty(this.state.files) ){

		return this.state.files.map((file, i) => {
			// Handle both new photos (data_uri) and existing photos (filename from backend)
			const imageSrc = file.data_uri || (file.filename ? `/stocks/photos/${file.filename}` : '');
			
			return (
				<Grid item xs={12} sm={6} md={3} key={i} 
					style={{
						textAlign: 'center',
					}}
				>
					<Box p={1} 
						style={{
							height:"150px",
						}}
					>
						<img src={imageSrc} alt={`Photo ${i + 1}`} style={{maxWidth: '100%', maxHeight: '100%'}} />
					</Box>
					<Box>
						<IconButton onClick={(e) => this.onRemoveImage(e, i)}>
							<CloseRounded color="error" />
						</IconButton>
					</Box>
				</Grid>
				// <div key={i} className={"fileinput fileinput-exists"} data-provides="fileinput">
				// 	<div className="fileinput-preview thumbnail" data-trigger="fileinput">
				// 		<img src={file.data_uri}/>
				// 	</div>
				// 	<div>
				// 		{/* <span className="btn btn-info btn-file waves-effect">
				// 			<span className="fileinput-exists">Modifier</span>
				// 			<input type="file" name="File" onChange={(e) => this.handleChange(e, i)} />
				// 		</span>
				// 		<a
				// 			className="btn btn-danger fileinput-exists waves-effect"
				// 			data-dismiss="fileinput"
				// 			onClick={(e) => this.onRemoveImage(e, i)}
				// 		>
				// 			Supprimer
				// 		</a> */}
				// 		<Button 
				// 			// variant="contained" 
				// 			color="secondary" 
				// 			// startIcon={<AttachFileRounded />} 
				// 		>
				// 			Modifier
				// 		</Button>
				// 		<input 
				// 			type="file" 
				// 			multiple 
				// 			name="..." 
				// 			style={{
				// 				display: 'none',
				// 			  }}
				// 			onChange={(e) => this.handleChange(e, i) }
				// 		/>
				// 	</div>
				// </div>
			)
		})
		}
			
	}
	displayFiles = () => {
		const { saved } = this.props;
		
		if( !isEmpty(this.state.files) ){

			return this.state.files.map((file, i) =>  (
				<div 
					key={i} 
					style={{ display:"table"}}
				>
					<span>{file.filename}</span>            
					<IconButton
						onClick={(e) => this.onRemoveImage(e, i)}
					>
						<CloseRounded color="error" />
					</IconButton>					
				</div>
				// <div 
				// 	key={i} 
				// 	className={"fileinput fileinput-exists"} 
				// 	style={{ display:"table"}}
				// >
				// 	<span className="fileinput-filename">{file.filename}</span>            
				// 	<span
				// 		className="close-sm fileinput-exists waves-effect"
				// 		onClick={(e) => this.onRemoveImage(e, i)}><CloseRounded /></span>
					
				// 	{/* <span
				// 		className="close-sm fileinput-exists waves-effect"
				// 		onClick={(e) => this.onRemoveImage(e, i)}>×</span>
				// 	*/}
				// </div>
			))
		}	else if (!isEmpty(saved)) {
			return this.props.saved.map((file, i) =>  (
				<ul 
					key={i} 
					style={{ display:"table"}}
				>
					<li>{file.original_name || `fichier ${i+1}`}</li>            
					{/* <IconButton
						onClick={(e) => this.onRemoveImage(e, i)}
					>
						<CloseRounded color="error" />
					</IconButton>					 */}
				</ul>
			))
		}
	}


	render() {
		const { file, id, buttonTitle } = this.props;
		const { files, max } = this.state;

		return (
			<Box p={1}>
                <input 
                    id={!isEmpty(id) ? id : "file-input"}
                    type="file" 
                    hidden
                    multiple
                    onChange={this.handleAddImage }
                />
                {(files.length < max) &&
					<Fragment>
						{file ? (
							<Button 
								variant="contained" 
								color="primary" 
								component="label"
								htmlFor={!isEmpty(id) ? id : "file-input"} 
								className="photoinput-new"
								startIcon={<AttachFileRounded />} 
							>
								{buttonTitle || "Ajouter un Fichier"}
							</Button>
						) : (
							<Button 
								variant="contained" 
								color="primary" 
								component="label"
								htmlFor={!isEmpty(id) ? id : "file-input"} 
								className="photoinput-new"
								startIcon={<CameraRounded />} 
							>
								{buttonTitle || "Ajouter une photo"}
							</Button>
						)}
					</Fragment>
                }
				<div>
					{file ? (
						this.displayFiles()
					) : (
						<Grid container spacing={1}>
							{this.displayPhotos()}
						</Grid>
					)}
				</div>

				{/* <span className="btn btn-info btn-file waves-effect">
					{file ? (
						<span className="fileinput-new"><i className="zmdi zmdi-attachment-alt"></i></span>
					) : (
						<span className="fileinput-new">+</span>
					)}
					<input type="file" 
						multiple 
						name="..." 
						onChange={(e) => this.handleAddImage(e) }
					/>
				</span> */}
			</Box>
			
		)
	}
}

export default Photos

export class Files extends Component {
	state = {
		files: this.props.photos,
		max: this.props.max || 4,
	}

	handleAddImage = async (e) => {
		e.preventDefault();
		let exist = this.state.files.length;
		let list = e.target.files;

		console.log("[INFO FILES], Upload Image list", list);

		let max = (exist + list.length) > this.state.max ? (this.state.max - exist) : list.length // 4 pics max

		for (let i = 0; i < max; i++) {
			let reader = new FileReader();
			let file = list[i];

			reader.onloadend = async (upload) => {
				console.log("[INFO]onloadend upload reader ",i, reader);

				this.setState({ 
				...this.state,  
				files:[
					...this.state.files, 
					{ 
						"data_uri": upload.target.result, 
						"filename": file.name,
						"filetype": file.type,
					}
				]
				})
				this.props.photoList(this.state.files) // send photoList to Products component
			}
			await reader.readAsDataURL(file)// ??
		}
	}
		
	handleChange = (e, index) => {
		e.preventDefault();
		console.log("[INFO FILES], Upload One Image", index);

		let reader = new FileReader();
		let file = e.target.files[0];
		var upload = {}

		let files = [
			...this.state.files.slice(0,index),
			{
				"data_uri": upload.target.result, 
				"filename": file.name,
				"filetype": file.type,
				
			},
			...this.state.files.slice(index+1),
		]
		reader.onloadend = (upload) => {
			this.setState({
				...this.state,
				files
			});
			this.props.photoList(this.state.files) // send photoList to src component
		}

		reader.readAsDataURL(file)
		
	}
	
	onRemoveImage = async (e, index) => {
		e.preventDefault();
		let files = [
			...this.state.files.slice(0,index), 
			...this.state.files.slice(index+1)
		]
		this.setState({
			...this.state,
			files
		});
		this.props.photoList(files)// send photoList to Products component
	}

	displayFiles = () => {
		console.log("[INFO FILES], DISPLAY files ", this.state.files);
		
		if( !isEmpty(this.state.files) ){

			return this.state.files.map((file, i) =>  (
				<div 
					key={i} 
					style={{ display:"table"}}
				>
					<span>{file.filename}</span>            
					<IconButton
						onClick={(e) => this.onRemoveImage(e, i)}
					>
						<CloseRounded color="error" />
					</IconButton>
					
					
				</div>
				// <div 
				// 	key={i} 
				// 	className={"fileinput fileinput-exists"} 
				// 	style={{ display:"table"}}
				// >
				// 	<span className="fileinput-filename">{file.filename}</span>            
				// 	<span
				// 		className="close-sm fileinput-exists waves-effect"
				// 		onClick={(e) => this.onRemoveImage(e, i)}><CloseRounded /></span>
					
				// 	{/* <span
				// 		className="close-sm fileinput-exists waves-effect"
				// 		onClick={(e) => this.onRemoveImage(e, i)}>×</span>
				// 	*/}
				// </div>
			))
		}	
	}


	render() {
		console.log("[STATE] FILES", this.state);
		const { file, id } = this.props;
		const { files, max } = this.state;

		return (
			<Box p={1}>
                <input 
                    id={!isEmpty(id) ? id : "file-input"}
                    type="file" 
                    hidden
                    multiple
                    onChange={this.handleAddImage }
                />
                {(files.length < max) &&
					<Button 
						variant="contained" 
						color="primary" 
						component="label"
						htmlFor={!isEmpty(id) ? id : "file-input"} 
						className="photoinput-new"
						startIcon={<AttachFileRounded />} 
					>
						Ajouter un Fichier
					</Button>
                }
				<div>
					{this.displayFiles()}
				</div>
			</Box>
			
		)
	}
}
